export default {
  "field-container": "_field-container_1puhdj",
  "dropdown-icon-field": "_dropdown-icon-field_1puhdj",
  "block-content": "_block-content_1puhdj"
};